import React,{ useEffect,useState,useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { Context } from '../../context/UserContext';

const Index = () => {

    const context = useContext(Context);
    const {readData} = useEntityCrud('Guild/GetAllGuilds');
    const {addData: updateData} = useEntityCrud('Guild/ChangeStatus');
    const [rows,setRows] = useState([]);

    const getData = () => {
        readData().then(({data}) => {
            if(data.status)
                setRows(data.result);
        });
    }

    useEffect(() => {
        getData();
    },[]);

    const deActiveRow = id => {
        const postedData = {
            id,
            status: false
        };
        updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('وضعیت صنف مورد نظر با موفقیت به روزرسانی شد');
                getData();
            }else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const activeRow = id => {
        const postedData = {
            id,
            status: true
        };
        updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('وضعیت صنف مورد نظر با موفقیت به روزرسانی شد');
                getData();
            }else
                data.errors.map(error => toast.error(error.message));
        });
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">اصناف</div>
            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary" to="create">ایجاد صنف / زیر صنف جدید</Link> : ''}
                {context.checkHasPermission('create') ? <hr /> : ''}
                {rows.length ? <div className="table-responsive"><table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            {/* <th>وضعیت</th> */}
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((item,index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.title}</td>
                                {/* <td>{item.isActive ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>}</td> */}
                                <td className="btn-list">
                                    <Link to={'sub-guilds/' + item.id} className="btn btn-icon mb-0 btn-warning" title="زیر صنف ها"><i className="fe fe-eye"></i></Link>
                                    <Link to={'/organizations/?guildId=' + item.id} className="btn btn-icon mb-0 btn-secondary" title="کسب و کار ها"><i className="fe fe-box"></i></Link>
                                    {context.checkHasPermission('update') ? <Link to={'update/' + item.id} className="btn btn-icon mb-0 btn-primary" title="ویرایش"><i className="fe fe-edit-2"></i></Link> : ''}
                                    {context.checkHasPermission('delete') ? (item.isActive ? <button onClick={e => deActiveRow(item.id)} className="btn btn-icon mb-0 btn-danger" title="غیرفعال سازی"><i className="fe fe-x"></i></button> : <button onClick={e => activeRow(item.id)} className="btn btn-icon mb-0 btn-success" title="فعال سازی"><i className="fe fe-check"></i></button>) : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>تعداد کل ردیف ها : {rows.length}</p>
                </div> : <div className="alert alert-info"><p>صنفی یافت نشد</p></div>}
            </div>
        </div>
    );
}

export default Index;